<div class="dialog-container">
    <div class="dialog-title-block">
        <h2 class="text-capitalize">{{ dialogData.implantType }} Implant Details</h2>
        <div class="flex-container">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block">
        <!-- Product Information Section -->
        <div class="content-section">
            <div class="section-header">
                <h3 class="section-title">Product Informatio00000n</h3>
            </div>
            <div class="app-border-grey">
                <div class="product-header">
                    <div class="product-info">
                        <div class="product-image">
                            <img class="img-sm" src="../../../assets/images/product_sm.png" alt="product" srcset="">
                        </div>
                        <div class="product-details">
                            <h2 class="product-name">{{ implantDetails?.product_name }}</h2>
                            <p class="last-updated">Last updated on {{ implantDetails?.last_updated_at }}</p>
                        </div>
                    </div>
                    <div class="product-status">
                        <span class="status-label">Status:</span>
                        <span class="status-badge" [ngClass]="'status-'+ implantDetails?.status">
                            {{ implantDetails?.status.charAt(0).toUpperCase() + implantDetails?.status.slice(1) }}
                        </span>
                    </div>
                </div>
                <div class="product-details-grid">
                    <div class="detail-row">
                        <span class="detail-label">Batch Number</span>
                        <span class="detail-value">{{ implantDetails?.batch_no }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Expiry Date</span>
                        <span class="detail-value">{{ implantDetails?.expiry_date }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Product Code</span>
                        <span class="detail-value">{{ implantDetails?.product_code }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">RFID</span>
                        <span class="detail-value">{{ implantDetails?.rfid }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Product Category</span>
                        <span class="detail-value">{{ implantDetails?.product_category }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Body Type</span>
                        <span class="detail-value">{{ implantDetails?.body_type }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Implant Type</span>
                        <span class="detail-value">{{ implantDetails?.implant_type }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Rate</span>
                        <span class="detail-value">&euro; {{ implantDetails?.rate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Activity Timeline Section -->
        <div class="content-section">
            <div class="section-header">
                <h3 class="section-title">Activity Timeline</h3>
            </div>
            <div class="app-border-grey">
                <div class="timeline-container">
                    <div class="timeline-item" *ngFor="let activity of activityTimeline; let i = index">
                        <div class="timeline-marker">
                            <div class="timeline-dot" [ngClass]="'dot-' + activity.type"></div>
                            <div class="timeline-line" *ngIf="i < activityTimeline.length - 1"></div>
                        </div>
                        <div class="timeline-content">
                            <div class="timeline-header">
                                <h4 class="timeline-title">{{ activity.title }}</h4>
                                <span class="timeline-time">{{ activity.timestamp }}</span>
                            </div>
                            <p class="timeline-description">{{ activity.description }}</p>
                            <div class="timeline-meta" *ngIf="activity.user">
                                <span class="timeline-user">By {{ activity.user }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="timeline-empty" *ngIf="!activityTimeline || activityTimeline.length === 0">
                        <div class="empty-state">
                            <svg class="empty-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#9ca3af"/>
                            </svg>
                            <h4 class="empty-title">No Activity Found</h4>
                            <p class="empty-description">No activity timeline available for this implant.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


